import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { renderPageTemplate } from "../../../../utils";

export default {
    title: "MyTrumpf/Page Templates/Company Admin/Detail",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html`
        <div class="ux-t-container">
            <div class="ux-row">
                <div class="ux-col-12 ux-u-mt-l ux-u-mb-s">
                    <a href="#" class="ux-button" title="back">
                        <ux-icon name="chevron-left"></ux-icon> Zurück
                    </a>
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-xs"
                    >
                        hanspeter.peterly@firma.de
                    </h2>
                    <div class="ux-row">
                        <div
                            class="ux-col-12 ux-col-md-6 ux-col-lg-4 ux-col-xl-3"
                        >
                            <h3
                                class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                            >
                                Persönliche Daten
                            </h3>
                            <div
                                class="ux-text-normal ux-text-normal--light-gray ux-u-mb-xxs"
                            >
                                <p class="ux-u-my-zero">
                                    Herr<br />
                                    Peter Peterle<br />
                                    13232/1241432
                                </p>
                            </div>
                        </div>
                        <div
                            class="ux-col-12 ux-col-md-6 ux-col-lg-5 ux-col-xl-2"
                        >
                            <h3
                                class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-my-zero"
                            >
                                Unternehmensdaten
                            </h3>
                            <div
                                class="ux-text-normal ux-text-normal--light-gray ux-u-mb-xxs"
                            >
                                <p class="ux-u-my-zero">
                                    Firma Lorem Ipsum <br />
                                    Musterstraße 123 <br />
                                    70174 Stuttgart <br />
                                    Deutschland <br />
                                    Kundennummer
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ux-t-container-full">
            <div class="ux-row"
                <div class="ux-col-12">
                    <ux-tab-container fix-to-top scroll-when-activated>
                        <ux-iws-async-tab
                            name="Rechteverwaltung"
                            tab-id="permissions-administration"
                            url="./mock-data/company-admin/user-administration-detail/permissions-administration.html"
                            class="ux-u-mt-xs ux-u-mb-s"
                        ></ux-iws-async-tab>
                    </ux-tab-container>
                </div>
                <div class="ux-col-10 ux-u-offset-1 ux-u-mb-s">
                    <a href="#" class="ux-button" title="back">
                        <ux-icon name="chevron-left"></ux-icon> Zurück
                    </a>
                </div>
            </div>
        </div>
    `;
};

export const Default = () => renderPageTemplate(() => Template());
